/**
 * @file How long a rejoin waits before its next attempt (#2223).
 *
 * Shared by the signed-in and the guest-link call so both bring people back
 * on the same schedule: attempt 1 fires at once, then 2 s, 4 s and 8 s,
 * then every 10 s for as long as the call lasts.
 */
const BACKOFF_MS = [2000, 4000, 8000];
const MAX_BACKOFF_MS = 10000;

/** Wait before attempt `next` (2 or later). */
export function rejoinDelayMs(next: number): number {
  return BACKOFF_MS[next - 2] ?? MAX_BACKOFF_MS;
}
